import { defineStore } from 'pinia'
export default defineStore({
  id: 'priceDataTable',
  persist: true,
  state: () => {
    return {
      isPriceVendorArchive: false
    }
  },
  actions: {
    setIsPriceVendorArchive: function (payload: any) {
      this.isPriceVendorArchive = payload
    }
  },
  getters: {
    getIsPriceVendorArchive: (state: any) => state.isPriceVendorArchive
  }
})
